import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { Button, Icon } from 'shared/components';
import BackgroundLayout from '../_layouts/BackgroundLayout';

import theme from './Page404.scss';

const propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
  goBack: PropTypes.func.isRequired,
  isExternalInit: PropTypes.bool.isRequired,
};

const Page404 = ({ goBack, intl, isExternalInit }) => (
  <BackgroundLayout>
    <div className={ theme.root }>
      <div className={ theme.main }>
        404
        <Icon name="broken-leg" className={ theme.icon } />
      </div>
      <div className={ theme.content }>
        <div>
          <FormattedMessage
            id="app.404.pageNotFound"
            defaultMessage="** Ouch! Page not found."
          />
        </div>
        <If condition={ !isExternalInit }>
          <Button
            testId="404-go-back-button"
            label={ intl.formatMessage({ id: 'const.button.goBack', defaultMessage: '** Go Back' }) }
            onClick={ goBack }
            iconName="arrow-left"
            iconPositionLeft
            iconPositionRtlNotReversed
          />
        </If>
      </div>
    </div>
  </BackgroundLayout>
);

Page404.propTypes = propTypes;

export default Page404;
